/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

/**
 * Search type constants for file search functionality
 */
export const SEARCH_TYPE_V2 = {
  filename: 'FILE_NAME',
  content: 'CONTENT',
  docUID: 'DOC_UID',
  all: 'all'
} as const

/**
 * Mapping from search type keys to API field names
 */
export const SEARCH_TYPE_PARSE = {
  [SEARCH_TYPE_V2.filename]: 'FILE_NAME',
  [SEARCH_TYPE_V2.content]: 'CONTENT',
  [SEARCH_TYPE_V2.docUID]: 'DOC_UID'
} as const

/**
 * Reverse mapping from API field values to UI searchType keys
 * Used when loading saved filters that store API field values
 */
export const API_FIELD_TO_SEARCH_TYPE: Record<string, string> = {
  FILE_NAME: 'filename',
  CONTENT: 'content',
  DOC_UID: 'docUID',
  ALL: 'all'
}

/**
 * Time range filter options for last updated date
 */
export const UPDATED_TYPE = {
  PAST1H: 'PAST1H',
  PAST24H: 'PAST24H',
  PAST1W: 'PAST1W',
  PAST1M: 'PAST1M',
  PAST1Y: 'PAST1Y',
  CUSTOM: 'CUSTOM'
} as const

/**
 * Item type filter options
 */
export const SEARCH_ITEM_TYPE = {
  DOCUMENT: 'DOCUMENT',
  FOLDER: 'FOLDER',
  ALL: 'ALL'
} as const

/**
 * Type definitions for constants
 */
export type SearchType = (typeof SEARCH_TYPE_V2)[keyof typeof SEARCH_TYPE_V2]
export type UpdatedType = (typeof UPDATED_TYPE)[keyof typeof UPDATED_TYPE]
export type SearchItemType = (typeof SEARCH_ITEM_TYPE)[keyof typeof SEARCH_ITEM_TYPE]
